module.exports = __webpack_public_path__ + "static/img/0.687c5abf.png";